import ObjectCache from './CacheService';
import LogicBaseCommentLikeApi from '../server/LogicBaseCommentLikeApi';
import UserAccount from '../UserAccount';
import LogicBaseCommentLike from '../../models/logicbasecommentlike';

class LogicBaseCommentLikeCache extends ObjectCache {
  api = LogicBaseCommentLikeApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseCommentLike(results._id, results.fr, results.c);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseCommentLikeCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
